@if(bootstrapService?.loadedRequiredData) {
  <router-outlet></router-outlet>
}